<template>
  <div class="component-content sub-content">
    <div class="list-title">
      <div class="r">
        <router-link :to="'/Storage/MaterialBack/' + this.form.houseId">
          <el-button type="primary" size="mini">材料退库申请</el-button>
        </router-link>
      </div>

      <label class="label-name">当前仓库：</label>
      <el-select size="small" class="organization-select" style="width:150px;" v-model="form.houseId"
        placeholder="请选择仓库">
        <el-option v-for="item in houseList" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>

      <label style="margin-left:10px;" class="label-name">搜索：</label>
      <el-input style="display:inline-block;width:300px;" v-model="filterKey" size="small"
        placeholder="你可以搜索材料退库单号"></el-input>

    </div>

    <div class="tab-radio-tool">
      <el-radio-group size="mini" v-model="form.type">
        <el-radio-button label="0">申请中/未退库材料</el-radio-button>
        <el-radio-button label="1">已退库材料</el-radio-button>
      </el-radio-group>
    </div>

    <el-table :data="paginationData" style="width: 100%" v-loading="loading">
      <el-table-column v-if="form.type == 1" label="退库单号" :key="keyNumber">
        <template slot-scope="scope">
          {{ scope.row.number }}
        </template>
      </el-table-column>
      <el-table-column label="客户名称" :key="keyNumber">
        <template slot-scope="scope">
          {{ scope.row.customer ? scope.row.customer : '/' }}
        </template>
      </el-table-column>
      <el-table-column label="所属工程" :key="keyNumber">
        <template slot-scope="scope">
          <router-link class="link" target="_blank" v-if="scope.row.projectId"
            :to="'/Project/Detail/' + scope.row.projectId">{{ scope.row.projectName }}</router-link>
          <span v-else>无</span>
        </template>
      </el-table-column>
      <el-table-column label="材料退库申请人" width="140" :key="keyNumber">
        <template slot-scope="scope">
          <user-info :userData='scope.row.creator'></user-info>
        </template>
      </el-table-column>
      <el-table-column label="申请时间" width="140" :key="keyNumber">
        <template slot-scope="scope">
          <span v-html="getDateByTime(scope.row.flow.createTime)"></span>
        </template>
      </el-table-column>
      <el-table-column v-if="form.type == 0" :key="keyNumber" label="审批状态" width="100">
        <template slot-scope="scope">
          <approval-status :flow="scope.row.flow" :approvals="scope.row.flow.approvals"
            :status="scope.row.flow.status"></approval-status>
        </template>
      </el-table-column>
      <!-- <el-table-column v-else :key="keyNumber" label="退库信息">
        <template slot-scope="scope">
          <a href="javascript:;" class="link" v-if="scope.row.backId" @click="ShowMaterialBack(scope.row)">
            已有退库记录
          </a>
          <span v-else>无</span>
        </template>
      </el-table-column> -->
      <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="材料退库申请详情" placement="bottom">
            <i class="iconfont icon-157 meeting-btn-icon mbi-detail" @click="projectDetail(scope.row)"></i>
          </el-tooltip>
          <span v-if="scope.row.creator.id == userData.id">
            <el-tooltip
              v-if="(scope.row.flow.status == '进行中' || scope.row.flow.status == '已拒绝' || scope.row.flow.status == '已取消')"
              class="item" effect="dark" content="修改该审批" placement="bottom">
              <i class="iconfont icon-xiugai meeting-btn-icon mbi-edit" @click="EditFlow(scope.row)"></i>
            </el-tooltip>
            <cancel-flow :successPlus='true' :flow="scope.row.flow" @getLists='getLists'></cancel-flow>
          </span>

          <span v-if="scope.row.flow.status == '审批通过' && isThisHouseManager(form.houseId)">
            <el-button size="mini" v-if="scope.row.type == 0" :loading="backLoading" @click="materialBack(scope.row)"
              type="success">退库
            </el-button>
          </span>
        </template>
      </el-table-column>

    </el-table>

    <el-pagination style="margin-left: -5px" v-if="form.pageTotal > form.pageSize" class="list-pagination" background
      :page-size="form.pageSize" :pager-count="9" :current-page="form.page + 1" layout="pager" :total="form.pageTotal"
      @current-change="handleCurrentChange">
    </el-pagination>

    <project-info></project-info>
  </div>
</template>

<script>
import {
  mapState
} from "vuex";

import CancelFlow from '@/components/CancelFlow'
import projectInfo from '@/page/user/projectInfo'
import approvalType from '@/Mixins/approvalType'

import UserInfo from '@/components/UserInfo'
import Role from '@/Mixins/role'
import ApprovalStatus from '@/components/ApprovalStatus'

export default {
  components: {
    UserInfo,
    projectInfo,
    ApprovalStatus,
    CancelFlow,
  },
  mixins: [approvalType, Role],
  computed: {
    ...mapState({
      organization: state => state.main.organization,
      userData: state => state.main.userData,
      fManagerStorage: state => state.storage.fManagerStorage,
    })
  },
  data() {
    return {
      // 是否可切换公司
      noSelectOrganization: false,
      houseList: "",

      organizationListData: [],
      depId: '',
      addMeetingRoomStatus: false,

      form: {
        houseId: '',
        page: 0,
        pageSize: 20,
        type: 0,
        number: ""
      },
      // 列表
      loading: true,
      pageSize: 20,
      currentPage: 1,
      listData: [],
      filterData: [],
      paginationData: [],
      // filter
      filterKey: "",
      filterTimeout: null,
      keyNumber: 999,

      backLoading: false,
    }
  },
  created() {
    if (this.$route.params.houseId) {
      this.form.houseId = this.$route.params.houseId / 1
    }
    this.organizationListData = this.organization[0].childDepts
    this.depId = this.userData.secDepIds.split(",")[0] / 1
    // 获取仓库列表
    this.getHouseList()
  },
  mounted() {
    if (this.depId == "7") {
      this.noSelectOrganization = false
      this.depId = ""
    }
  },
  methods: {
    // 材料领用申请编辑
    EditFlow(row) {
      this.$router.push({
        path: '/Storage/MaterialBack',
        query: {
          applyId: row.flow.applyId,
        }
      })

    },
    // 材料退库
    materialBack(row) {
      this.backLoading = true
      ajax.post('/storage/material/back', {
        applyId: row.id
      }, (res) => {
        this.backLoading = false
        this.$message.success("材料退库成功")
        this.getLists()
      })
    },
    // 显示审批表详情
    projectDetail(row) {
      // console.log(row)
      let _projectTable = {
        status: true,
        applyId: row.id,
        // 强行吧tableType变成50 也就是仓库材料
        tableType: '51',
      }
      this.$store.commit('set_projectTable', _projectTable)
    },
    getDateByTime(time) {
      // return time
      return window.util.getFormatDate(time, true)
    },
    // 获取仓库列表
    getHouseList() {
      ajax.get('/storage/house/list', {
        'depId': this.depId,
        level: '1'
      }, (res) => {
        this.loading = false
        this.houseList = res.vo.array
        this.houseList = util.arrConcatUnRepeat(this.houseList, this.fManagerStorage)

        if (!this.form.houseId && this.houseList.length > 0) {
          this.form.houseId = this.houseList[0].id
        }
        // 获取库存
        this.getLists()
      })
    },
    // 当前页
    handleCurrentChange(val) {
      this.form.page = val - 1;
      this.getLists();
    },
    // 搜索筛选新闻数据
    getFilterData() {
      this.form.page = 0;
      this.getLists();
    },
    // 分页筛选数据
    getPaginationData() {
      // 分页筛选
      this.paginationData = this.filterData;
    },
    // 获取列表
    getLists() {
      this.loading = true
      let _url = '/storage/material/back/apply/list'
      this.form.number = this.filterKey;
      this.keyNumber++;

      ajax.get(_url, this.form, (res) => {
        this.loading = false
        this.filterData = this.listData = res.vo.list
        this.form.pageTotal = res.vo.size;
        this.getPaginationData()
      })
    },
  },
  watch: {
    'form.houseId'() {
      this.filterKey = ""
      this.getLists()
    },
    'form.type'() {
      this.filterKey = ""
      this.getLists()
    },
    filterKey() {
      clearTimeout(this.filterTimeout);
      this.filterTimeout = setTimeout(() => {
        this.getFilterData();
      }, 350)
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/page/storage/materialBackList.vue